class Dependency {
    constructor({
        id = '',
        dependencyType,
    }) {
        this.id = id.toUpperCase()
        this.dependencyType = dependencyType
    }

    toJSON() {
        return {
            id: this.id,
            dependencyType: this.dependencyType,
        }
    }
}

export default Dependency
